export default "__VITE_ASSET__F5RUi42W__"